import * as React from 'react';
import { ReactElement, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Auth from 'modules/Auth';
import Local from 'modules/Local';
import { PermissionsEnum } from 'consts/permissions';

interface Props {
  component: React.ComponentType;
  pageAccessPermission?: PermissionsEnum;
}

const Private = <P extends Props>(props: Props): ReactElement => {
  const navigate = useNavigate();
  const { pageAccessPermission, component: Component } = props;

  useEffect(() => {
    const checkAccess = async (): Promise<void> => {
      const authenticated = await Auth.isAuthenticated();
      if (!authenticated) return;

      const hasViewPermission = pageAccessPermission ? Auth.hasPermission(pageAccessPermission) : true;
      if (!hasViewPermission) {
        navigate('/accessdenied');
      } else if (!Local.getEnvironmentId()) {
        navigate('/landing');
      }
    };

    checkAccess();
  }, [pageAccessPermission]);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...(props as P)} />;
};

export default Private;
